module.exports = __webpack_public_path__ + "static/media/users-home01.c5064a54.png";